import React, { useState } from "react";
import { FormWrapper } from "./forms/FormWrapper";
import { AddAndCloseButton } from "./generic/AddAndCloseButton";
import { CloseButton } from "./generic/CloseButton";
import { TileList } from "./generic/TileList";
import { Tile } from "./generic/Tile";

export const ChooseIngredientsModal = ({
  onClose,
  addProduct,
  ingredients,
}) => {
  const [ingredientsToAdd, setIngredientsToAdd] = useState(
    ingredients.reduce((acc, ele) => ({ ...acc, [ele]: true }), {})
  );

  return (
    <FormWrapper>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TileList>
          {Object.entries(ingredientsToAdd).map(([ingredient, add]) => (
            <Tile
              key={ingredient}
              style={{ backgroundColor: add ? "green" : "red" }}
              onClick={() => {
                setIngredientsToAdd({
                  ...ingredientsToAdd,
                  [ingredient]: !add,
                });
              }}
            >
              {ingredient}
            </Tile>
          ))}
        </TileList>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "2rem",
          }}
        >
          <AddAndCloseButton
            onClick={() => {
              Object.entries(ingredientsToAdd).forEach(([ingredient, add]) => {
                if (add) addProduct({ name: ingredient });
              });
              onClose();
            }}
          />

          <CloseButton onClick={onClose} />
        </div>
      </div>
    </FormWrapper>
  );
};
